import moment from 'moment';
import React, { Component } from 'react';
import CacheInfo from '../../cacheInfo';
import ChainageChart from '../chainageChart/chart';
import ChartContainer from '../measurement-chart/chart-container';
import RangeInput from '../measurement-chart/range-input';
import { getMinimalRangeLimits, getZeroRangeLimits, checkRangeLimits, adjustRangeConstraints } from './getNextDataUtils.js';
const dateFormat = 'YYYY-MM-DD';

const oneDayMs = 86400000;
const oneWeekMs = oneDayMs * 7

const api = abp.services.api.measurementChartClientApi;
const chartsMemoryStore = new Map();

const hasRenderableCharts = (charts) => {
    return Array.isArray(charts) && charts.length > 0 && charts[0] && charts[0].data && charts[0].options;
};

const isForceRefreshRequested = () => {
    const currentUrl = new URL(window.location.href);
    const rawValue = currentUrl.searchParams.get('forceRefresh');
    if (!rawValue) {
        return false;
    }

    return rawValue === '1' || rawValue.toLowerCase() === 'true';
};

const appendQueryParams = (url, queryParams) => {
    const targetUrl = new URL(url, window.location.origin);
    Object.keys(queryParams).forEach((key) => {
        const value = queryParams[key];
        if (value === undefined || value === null || value === '') {
            return;
        }
        targetUrl.searchParams.set(key, value);
    });
    return `${targetUrl.pathname}${targetUrl.search}`;
};

class MeasurementChartGroup extends Component {
    constructor(props) {
        super(props);
        const initialCharts = Array.isArray(props.charts) ? props.charts : [];
        this.state = {
            rangeInstances: [],
            chartInstances: [],
            hiddenPoints: [],
            hiddenDatasets: [],
            charts: initialCharts,
            chartsLoading: props.loadChartsAsync && !hasRenderableCharts(initialCharts),
            chartsLoadError: null
        };
    }

    getHiddenPointIds = () => this.state.hiddenPoints
    getHiddenDatasets = () => this.state.hiddenDatasets

    registerRangeInstance = (instance) => {
        let newInstances = this.state.rangeInstances;
        newInstances.push(instance);
        this.setState({ rangeInstances: newInstances });
    }

    registerChartInstance = (instance) => {
        let newInstances = this.state.chartInstances;
        newInstances.push(instance);
        this.setState({ chartInstances: newInstances });
    }

    globalRangeInstance = null;

    registerGlobalRangeInstance = (instance) => {
        this.globalRangeInstance = instance;
        this.updateFromToInUrl(moment(instance.state.currentMin), moment(instance.state.currentMax));
    }

    onParentDateRangeChanged = (minVal, maxVal) => {
        this.refreshRanges(minVal, maxVal);
    }

    onPlotVisibilityChanged = (event, item) => {
        const datasetName = item.text;
        for (let i = 0; i < this.state.chartInstances.length; i++) {
            let instance = this.state.chartInstances[i];
            var ci = instance.refs.chart.chartInstance;
            let datasetId = ci.data.datasets.findIndex(x => x.label == datasetName);
            if (datasetId == -1) { continue; }
            try {
                var meta = ci.getDatasetMeta(datasetId);
                meta.hidden = (meta.hidden === null) ? !ci.data.datasets[datasetId].hidden : null;
                if (instance.props.isLongitudinalProfileChart === true) {
                    const measurementDate = ci.chart.data.datasets[datasetId].data[0].metadata.measurementDate;
                    if (!isNullOrUndefined(measurementDate)) {
                        if (meta.hidden === true || (meta.hidden === null && ci.data.datasets[datasetId].hidden)) {
                            if (!this.state.hiddenDatasets.includes(measurementDate)) {
                                let hiddenDatasets = this.state.hiddenDatasets
                                hiddenDatasets.push(measurementDate)
                                this.setState({ hiddenDatasets });
                            }
                        }
                        else {
                            if (this.state.hiddenDatasets.includes(measurementDate)) {
                                const hiddenDatasets = this.state.hiddenDatasets.filter(p => p !== measurementDate)
                                this.setState({ hiddenDatasets });
                            }
                        }
                    }
                } else {
                    const pointId = ci.chart.data.datasets[datasetId].data.length > 0 ? ci.chart.data.datasets[datasetId].data[0].pointId : null;
                    if (!isNullOrUndefined(pointId)) {
                        if (meta.hidden === true || (meta.hidden === null && ci.data.datasets[datasetId].hidden)) {
                            if (!this.state.hiddenPoints.includes(pointId)) {
                                let hiddenPoints = this.state.hiddenPoints
                                hiddenPoints.push(pointId)
                                this.setState({ hiddenPoints });
                            }
                        }
                        else {
                            if (this.state.hiddenPoints.includes(pointId)) {
                                const hiddenPoints = this.state.hiddenPoints.filter(p => p !== pointId)
                                this.setState({ hiddenPoints });
                            }
                        }
                    } else if (instance.props.excavationIds && !isNullOrUndefined(datasetName)) {
                        if (meta.hidden === true || (meta.hidden === null && ci.data.datasets[datasetId].hidden)) {
                            if (!this.state.hiddenDatasets.includes(datasetName)) {
                                let hiddenDatasets = this.state.hiddenDatasets
                                hiddenDatasets.push(datasetName)
                                this.setState({ hiddenDatasets });
                            }
                        }
                        else {
                            if (this.state.hiddenDatasets.includes(datasetName)) {
                                const hiddenDatasets = this.state.hiddenDatasets.filter(p => p !== datasetName)
                                this.setState({ hiddenDatasets });
                            }
                        }
                    }
                }
                ci.update();
            } catch (e) {
                console.log(e)
            }
        }
    }

    chainageRangeLoaded = {
        from: null,
        to: null
    }
    longitudinalProfileChart = {
        loadedFrom: null,
        loadedTo: null,
        instance: null
    }

    initAxisScaling = (chartInstance) => {
        if (!chartInstance.scaling.verticalAxisMin) {
            chartInstance.scaling.verticalAxisMin = chartInstance.props.data.scalingSettings.dataYAxisMin;
            chartInstance.scaling.verticalAxisMax = chartInstance.props.data.scalingSettings.dataYAxisMax;
        }
        if (!chartInstance.scaling.horizontalAxisMin) {
            chartInstance.scaling.horizontalAxisMin = chartInstance.props.data.scalingSettings.dataXAxisMin;
            chartInstance.scaling.horizontalAxisMax = chartInstance.props.data.scalingSettings.dataXAxisMax;
        }
    }

    lpLoadingWorkerActive = false;
    lpLoadingWorkerBuffer = []; //adding:bool from:Date to:Date prepend:bool

    lpLoadingAddWork = (from, to) => {
        this.lpLoadingWorkerBuffer.push({ from: from, to: to });
        this.lpLoadingWorker(false);
    }

    lpLoadingWorker = (fromCallback) => {
        const instance = this.longitudinalProfileChart.instance;
        const chart = instance.refs.chart.chartInstance;
        if (!fromCallback) {
            if (this.lpLoadingWorkerActive) return;
            this.lpLoadingWorkerActive = true;
            instance.setState({ dataIsLoading: true })
        }
        while (this.lpLoadingWorkerBuffer.length > 0) {
            let work = this.lpLoadingWorkerBuffer.shift();     
                this.requestNextLPData(work.from, work.to);
                return;
        }
        this.lpLoadingWorkerActive = false;
        instance.setState({ dataIsLoading: false });
        chart.update();
    }

    getHiddenDatasetsList = (chart) => {
      let hiddenDatasetsList = [];
      chart.data.datasets.forEach((dataset, i) => {
        const meta = chart.getDatasetMeta(i);
        const hidden = (meta.hidden === null) ? chart.data.datasets[i].hidden : meta.hidden;
        if (hidden) hiddenDatasetsList.push(dataset.label);
      });
      return hiddenDatasetsList;
    }

    restoreHiddenDatasets = (hiddenDatasetsList, chart) => {
      if (hiddenDatasetsList.length > 0) {
        chart.data.datasets.forEach((dataset, i) => {
          if (hiddenDatasetsList.indexOf(dataset.label) !== -1) {
            const meta = chart.getDatasetMeta(i);
            meta.hidden = dataset.hidden ? null : true;
          }
        });
      }
    }

    loadNextLPData = (data) => {
        const instance = this.longitudinalProfileChart.instance;
        const chart = instance.refs.chart.chartInstance;
        if (!chart || !instance || !data || data.lenght == 0) {
          this.lpLoadingWorker(true);
          return;
        }
        this.initAxisScaling(instance);
        let hiddenDatasetsList = this.getHiddenDatasetsList(chart); //get list of hidden datasets

        //reset limits
        let rangeLimits = getZeroRangeLimits();
        let rangeHLimits = getZeroRangeLimits();
        if (data.length > 0) { //have any data
            let existingDatasets = chart.data.datasets
            existingDatasets.forEach(existingDataset => {
                let index = data.map(e => e.label).indexOf(existingDataset.label);
                if (index != -1) {
                    existingDataset.data = data[index].data
                    data.splice(index, 1, existingDataset)
                }
            })
            //set impossible limits to be extended by data
            rangeLimits = getMinimalRangeLimits();
            rangeHLimits = getMinimalRangeLimits();
            //extend limits by new data
            data.forEach(dataset => {
                dataset.data.forEach(point => {
                    checkRangeLimits(rangeLimits, point.y);
                    checkRangeLimits(rangeHLimits, point.x)
                })
            });
            chart.data.datasets = data;
          this.restoreHiddenDatasets(hiddenDatasetsList, chart);
          //set scale to calculated limits
          adjustRangeConstraints(rangeLimits, instance, 1, true);
          adjustRangeConstraints(rangeHLimits, instance, 1, false);
        }
        this.lpLoadingWorker(true);
    };

    requestNextLPData = (fromMoment, toMoment) => {
        api.getAdditionalLongitudinalProfileData(
            this.longitudinalProfileChart.instance.props.profileId,
            fromMoment.format('YYYY-MM-DD'), 
            toMoment.format('YYYY-MM-DD')
        ).done(data => {
            this.loadNextLPData(data);
        });
    };

    refreshRanges = (minVal, maxVal) => {
        //const { showChainageExcavationChart } = this.props;
        for (let i = 0; i < this.state.rangeInstances.length; i++) {
            let instance = this.state.rangeInstances[i];
            if (instance.props.valueIsDate) {
              instance.setState({ currentMax: maxVal, currentMin: minVal });
              if (!instance.props.excavationIds) {
                  instance.props.onMinChanged(minVal);
                  instance.props.onMaxChanged(maxVal);
                  instance.props.onParentDateRangeChanged(minVal, maxVal);
              }
            }
            if (instance.props.excavationIds) {
                instance.refs.chart.chartInstance.options.scales.xAxes[0].time.min = minVal
                instance.refs.chart.chartInstance.options.scales.xAxes[0].time.max = maxVal
                instance.refs.chart.chartInstance.update()
            } 
        }
        let fromVal = moment(minVal).startOf("day").valueOf();
        let toVal = moment(maxVal).startOf("day").valueOf();
        this.updateFromToInUrl(moment(fromVal), moment(toVal));
        /*
         * dynamic loading of chainages not implemented yet
        if (showChainageExcavationChart) {
            if (fromVal < this.chainageRangeLoaded.from) {
                //load data moment(fromVal) - moment(this.chainageRangeLoaded.from)
                this.chainageRangeLoaded.from = fromVal;
            }
            if (toVal > this.chainageRangeLoaded.to) {
                //load data moment(this.chainageRangeLoaded.to).format('DD.MM.YYYY') - moment(toVal)
                this.chainageRangeLoaded.to = toVal;
            }
        }*/
        if (this.longitudinalProfileChart.instance != null) {
            this.lpLoadingAddWork(moment(fromVal), moment(toVal));
        }
    }

    updateFromToInUrl = (from, to) => {
        const exportDetailLink = document.querySelector("a#exportDetail");
        const exportLink = document.querySelector("button#export");
        if (exportDetailLink) {
            let exportDetailUrl = exportDetailLink.getAttribute("href");
            if (exportDetailUrl.indexOf("?") == -1) {
                exportDetailUrl = exportDetailUrl + "?";
            }
            const dateFrom = from.format('YYYY-MM-DD');
            if (exportDetailUrl.indexOf("dateFrom=") !== -1) {
                let urlParams = new URLSearchParams(new URL(location.origin + exportDetailUrl).search);
                urlParams.set(`dateFrom`, dateFrom);
                exportDetailUrl = `${exportDetailUrl.split("?")[0]}?${decodeURIComponent(urlParams.toString())}`;
            } else {
                exportDetailUrl += `&dateFrom=${dateFrom}`;
            }
            const dateTo = to.format('YYYY-MM-DD');
            if (exportDetailUrl.indexOf("dateTo=") !== -1) {
                let urlParams = new URLSearchParams(new URL(location.origin + exportDetailUrl).search);
                urlParams.set(`dateTo`, dateTo);
                exportDetailUrl = `${exportDetailUrl.split("?")[0]}?${decodeURIComponent(urlParams.toString())}`;
            } else {
                exportDetailUrl += `&dateTo=${dateTo}`;
            }
            exportDetailLink.setAttribute("href", exportDetailUrl);
            if (exportLink) {
                exportLink.setAttribute("href", exportDetailUrl);
            }
        }
    };

    updateExcludedFiltersInUrl = () => {
        const exportDetailLink = document.querySelector("a#exportDetail");
        const exportLink = document.querySelector("button#export");
        if (!exportDetailLink) {
            return;
        }

        const exportDetailHref = exportDetailLink.getAttribute("href") || "";
        const exportDetailUrl = exportDetailHref.split("?")[0];
        const exportDetailQuery = exportDetailHref.split("?")[1] || "";
        const preserved = exportDetailQuery
            .split("&")
            .filter(s => s && !s.includes("excludedPointIds") && !s.includes("excludedDatasets"));

        const urlParams = new URLSearchParams();
        urlParams.set("excludedPointIds", this.state.hiddenPoints.join());
        urlParams.set("excludedDatasets", this.state.hiddenDatasets.join());

        const nextHref = `${exportDetailUrl}?${urlParams.toString()}${preserved.length > 0 ? `&${preserved.join("&")}` : ""}`;
        exportDetailLink.setAttribute("href", nextHref);
        if (exportLink) {
            exportLink.setAttribute("href", nextHref);
        }
    };


    componentDidMount() {
        const forceRefresh = isForceRefreshRequested();
        if (this.props.loadChartsAsync && !hasRenderableCharts(this.state.charts)) {
            this.prefetchCharts(forceRefresh);
        } else {
            this.prepareLongitudinalProfileChart();
            this.stripOneTimeForceRefreshFromUrl();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.hiddenPoints !== this.state.hiddenPoints || prevState.hiddenDatasets !== this.state.hiddenDatasets) {
            this.updateExcludedFiltersInUrl();
        }

        if (prevState.charts !== this.state.charts) {
            this.prepareLongitudinalProfileChart();
        }
    }

    prefetchCharts = (forceRefresh = false) => {
        const { profileId, chartsDataUrl } = this.props;
        if (!profileId || !chartsDataUrl) {
            this.setState({ chartsLoading: false });
            return;
        }

        const requestUrl = appendQueryParams(chartsDataUrl, {
            forceRefresh: forceRefresh ? 'true' : null
        });
        const storeKey = `${profileId}|${requestUrl}`;
        const storeItem = forceRefresh ? null : chartsMemoryStore.get(storeKey);

        if (storeItem && storeItem.charts) {
            this.setState({
                charts: storeItem.charts,
                chartsLoading: false,
                chartsLoadError: null
            }, () => this.stripOneTimeForceRefreshFromUrl());
            return;
        }

        if (storeItem && storeItem.request) {
            this.setState({ chartsLoading: true, chartsLoadError: null });
            storeItem.request
                .done((charts) => this.applyLoadedCharts(charts, storeKey))
                .fail(() => this.setState({ chartsLoading: false, chartsLoadError: 'Nepodařilo se načíst grafy.' }, () => this.stripOneTimeForceRefreshFromUrl()));
            return;
        }

        const request = $.getJSON(requestUrl);
        chartsMemoryStore.set(storeKey, { request: request });
        this.setState({ chartsLoading: true, chartsLoadError: null });

        request
            .done((charts) => this.applyLoadedCharts(charts, storeKey))
            .fail(() => {
                chartsMemoryStore.delete(storeKey);
                this.setState({ chartsLoading: false, chartsLoadError: 'Nepodařilo se načíst grafy.' }, () => this.stripOneTimeForceRefreshFromUrl());
            });
    }

    applyLoadedCharts = (charts, storeKey) => {
        const loadedCharts = Array.isArray(charts) ? charts : [];
        chartsMemoryStore.set(storeKey, { charts: loadedCharts });
        this.setState({
            charts: loadedCharts,
            chartsLoading: false,
            chartsLoadError: null
        }, () => this.stripOneTimeForceRefreshFromUrl());
    }

    prepareLongitudinalProfileChart = () => {
        for (let i = 0; i < this.state.chartInstances.length; i++) {
            let instance = this.state.chartInstances[i];
            if (instance.props.isLongitudinalProfileChart !== true) continue;
            this.longitudinalProfileChart.instance = instance;
            let hiddenDatasets = this.state.hiddenDatasets;
            for (let datasetId = 0; datasetId < instance.props.data.dataSets.length; datasetId++) {
                if (instance.props.data.dataSets[datasetId].hidden !== true) continue;
                hiddenDatasets.push(instance.props.data.dataSets[datasetId].data[0].metadata.measurementDate);
            }
            this.setState({ hiddenDatasets });
            this.longitudinalProfileChart.loadedFrom = moment(this.globalRangeInstance.state.currentMin).startOf("day").valueOf();
            this.longitudinalProfileChart.loadedTo = moment(this.globalRangeInstance.state.currentMax).startOf("day").valueOf();
        }
    }

    stripOneTimeForceRefreshFromUrl = () => {
        const currentUrl = new URL(window.location.href);
        if (!currentUrl.searchParams.has('forceRefresh')) {
            return;
        }

        currentUrl.searchParams.delete('forceRefresh');
        window.history.replaceState({}, document.title, `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
    }

    render = () => {
        const { showChainageExcavationChart, excavationChart, profileId } = this.props;
        const { charts, chartsLoading, chartsLoadError } = this.state;
        if (!hasRenderableCharts(charts)) {
            if (chartsLoading) {
                return (
                    <div className="text-center p-4">
                        <i className="fa fa-spinner fa-spin" /> Načítám grafy...
                    </div>
                );
            }

            if (chartsLoadError) {
                return <div className="alert alert-warning m-3">{chartsLoadError}</div>;
            }

            return <div />;
        }

        const rows = [];
        for (let i = 0; i < charts.length; i++) {
            rows.push(this.renderContainer(charts[i], i, profileId));
        }

        let isFirstLongitudinalProfileChart = charts[0].isLongitudinalProfileChart;

        //get scales from first chart, x asis is same on all charts
        const xAxisScalingControl = charts[0].options.scalingControls.xAxisScalingControl;
        const xAxes = charts[0].options.scales.xAxes;

        const lastXAxisMax = getValueOrDefault(charts[0].data.scalingSettings.lastXAxisMax, 10);
        const lastXAxisMin = getValueOrDefault(charts[0].data.scalingSettings.lastXAxisMin, -10);
        const dataXAxisMax = getValueOrDefault(charts[0].data.scalingSettings.dataXAxisMax, 10);
        const dataXAxisMin = getValueOrDefault(charts[0].data.scalingSettings.dataXAxisMin, -10);
        const dataXAxisMaxPos = getValueOrDefault(charts[0].data.scalingSettings.dataXAxisMaxPos, 10);
        const dataXAxisMinPos = getValueOrDefault(charts[0].data.scalingSettings.dataXAxisMinPos, -10);

        const xScaleUnit = getValueOrDefault(charts[0].options.scales.xAxes[0].time.unit, 'day');
        this.chainageRangeLoaded.from = moment(dataXAxisMinPos).startOf("day").valueOf();
        this.chainageRangeLoaded.to = moment(dataXAxisMaxPos).startOf("day").valueOf();

        return (
            <div>
                <CacheInfo cachedTime={charts[0].cachedTime} cacheEntities={'ProfileGraph'} entityId={`${profileId}`} reloadWithForceRefresh={true}></CacheInfo>
                <div className={'scaling-controls'}>
                    {!isFirstLongitudinalProfileChart && <RangeInput 
                        min={dataXAxisMin}
                        max={dataXAxisMax}
                        //values={[lastXAxisMin || dataXAxisMinValue, lastXAxisMax || dataXAxisMaxValue]}
                        values={[dataXAxisMinPos, dataXAxisMaxPos]}
                        step={xAxisScalingControl.stepSize || oneWeekMs}
                        valueIsDate={xAxes.some(x => x.type === 'time')}
                        useDataMax={xAxisScalingControl.useAlwaysDataMax}
                        label={'Ovládání všech grafů'}
                        registerRangeReference={this.registerGlobalRangeInstance}
                        onParentDateRangeChanged={this.onParentDateRangeChanged} />}
                    {showChainageExcavationChart &&
                        <ChainageChart
                            height={excavationChart.height}
                            excavationIds={excavationChart.excavationIds}
                            coordinates={excavationChart.coordinates}
                            profileId={excavationChart.profileId}
                            registerRangeReference={this.registerRangeInstance}
                            registerChartReference={this.registerChartInstance}
                            onPlotVisibilityChanged={this.onPlotVisibilityChanged}
                            annotation={excavationChart.annotationWrapper}
                            dataXAxisMin={dataXAxisMinPos}
                            dataXAxisMax={dataXAxisMaxPos}
                            xScaleUnit={xScaleUnit}
                            hideHeader={excavationChart.hideHeader} />}
                </div>
                <ul className={'p-0'}>
                    {rows}
                </ul>
            </div>);
    }

    renderContainer = (model, index, profileId) => {
        return (
            <ChartContainer
                key={index}
                chartName={model.chartName}
                options={model.options}
                data={model.data}
                loadData={model.loadData}
                dataPreloaded={model.dataPreloaded}
                clearChart={model.clearChart}
                axesRangesChanged={this.axesRangesChanged}
                registerRangeReference={this.registerRangeInstance}
                registerChartReference={this.registerChartInstance}
                onPlotVisibilityChanged={this.onPlotVisibilityChanged}
                isLongitudinalProfileChart={model.isLongitudinalProfileChart}
                yParameterTypeIds={model.yParameterTypeIds}
                height={model.height}
                getHiddenPointIds={this.getHiddenPointIds}
                getHiddenDatasets={this.getHiddenDatasets}
                profileId={profileId}
                useLiveDataAccessor={model.useLiveDataAccessor}
            />
        )
    }  
}

const isNullOrUndefined = val => {
    return val === null || val === undefined;
};

const getValueOrDefault = (val, defaultValue) => {
    return isNullOrUndefined(val) ? defaultValue : val;
};

export default MeasurementChartGroup;



// WEBPACK FOOTER //
// ./App/components/modules/measurement-chart-group/chart-group.js